module.exports = __webpack_public_path__ + "img/property-default-image.06fc1048.png";